import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Eyebrow, Reveal } from "../Reveal";
import { PROJECTS } from "../../data/site";

const Tag = ({ children }) => (
  <span className="border border-charcoal/20 px-3 py-1 font-heading text-[11px] font-bold uppercase tracking-[0.16em] text-ink">
    {children}
  </span>
);

export const Projects = () => (
  <section id="projects" data-testid="projects-section" className="section-pad bg-warm">
    <div className="container-cando">
      <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-8">
          <Reveal>
            <Eyebrow>Our Work</Eyebrow>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="h2 mt-6 max-w-xl text-charcoal">Built for Real Homes. Built to Last.</h2>
          </Reveal>
        </div>
        <div className="lg:col-span-4 lg:text-right">
          <Reveal delay={0.16}>
            <Link to="/contact" data-testid="projects-cta" className="link-arrow group">
              Start Your Project
              <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>
      </div>

      <div className="mt-16 grid gap-10 lg:grid-cols-12" data-testid="projects-grid">
        {PROJECTS.map((p, i) => (
          <Reveal
            key={p.name}
            delay={i * 0.1}
            className={i === 0 ? "lg:col-span-7" : i === 1 ? "lg:col-span-5" : "lg:col-span-12"}
          >
            <article data-testid={`project-card-${i}`} className="group">
              <div className="overflow-hidden">
                <img
                  src={p.img}
                  alt={p.name}
                  loading="lazy"
                  className={`w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04] ${
                    i === 2 ? "aspect-[21/9]" : "aspect-[4/3]"
                  }`}
                />
              </div>
              <div className="flex flex-wrap items-start justify-between gap-4 pt-6">
                <div>
                  <p className="font-heading text-[12px] font-bold uppercase tracking-[0.22em] text-bronze">
                    {p.location}
                  </p>
                  <h3 className="h3 mt-2 text-charcoal">{p.name}</h3>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {p.tags.map((t) => (
                      <Tag key={t}>{t}</Tag>
                    ))}
                  </div>
                </div>
                <Link
                  to="/contact"
                  data-testid={`project-view-${i}`}
                  className="link-arrow group/link mt-2"
                >
                  View Project
                  <ArrowRight size={15} className="transition-transform duration-300 group-hover/link:translate-x-1" />
                </Link>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
